import { Component, Input, OnInit } from '@angular/core';
import { CommonsText } from 'app/commons/CommonsText';
import { EventService } from 'app/services/event-service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-indemnizaciones-parte',
    templateUrl: './indemnizaciones-parte.component.html',
    styleUrls: ['./indemnizaciones-parte.component.scss']
})
export class IndemnizacionesParteComponent implements OnInit {

    @Input() data: any;
    indemnizaciones: any[] = undefined;
    flag: boolean = false;

    constructor(
        private eventService: EventService,
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        this.traerIndemnizaciones();
    }

    traerIndemnizaciones() {
        if (!this.flag) {
            this.flag = true;
            this.eventService.getIndemnizaciones(this.data.eventNumber)
                .then(value => {
                    this.indemnizaciones = value.response || [];
                })
                .catch(error => {
                    this.indemnizaciones = [];
                    this.toastr.error(CommonsText.PROBLEMA_SERVICIO_INDEMNZACIONES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                        timeOut: 5000
                    });
                });
        }
    }
}
